<template>
    <v-dialog 
        v-model="showModalIndex"
        v-if="showModalIndex"
        persistent
        @click:outside="closeModal">
      <v-icon
          @click="closeModal"
          class="close-content-btn">mdi-close</v-icon>

        <v-simple-table
            class="border-table"
        >
          <template v-slot:default>
            <thead>
            <tr class="item-table-header">
              <th rowspan="2" class="text-center">Nguồn</th>
              <th class="text-center" colspan="2">Sáng</th>
              <th class="text-center" colspan="2">Chiều</th>
              <th class="text-center" colspan="2">Tối</th>
            </tr>
            <tr class="item-table-sub-header">
              <th class="text-center">Tổng</th>
              <th class="text-center">Phân bổ</th>
              <th class="text-center">Tổng</th>
              <th class="text-center">Phân bổ</th>
              <th class="text-center">Tổng</th>
              <th class="text-center">Phân bổ</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(itemSource, index) in allotment.sources">
              <td class="text-center">{{ itemSource.name }}</td>
              <td class="text-center" rowspan="3" v-if="index == 0">
                {{ allotment.total_m }}
              </td>
              <td class="text-center">
                {{ itemSource.numberOfContactM }}
              </td>
              <td class="text-center" rowspan="3" v-if="index == 0">
                {{ allotment.total_a }}
              </td>
              <td class="text-center">
                {{ itemSource.numberOfContactA }}
              </td>
              <td class="text-center" rowspan="3" v-if="index == 0">
                {{ allotment.total_e }}
              </td>
              <td class="text-center">
                {{ itemSource.numberOfContactE }}
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
    </v-dialog>
</template>

<script>
export default {
  props: {
    showModalIndex: {
      type: Boolean,
      default: false
    },
    allotment: {
      type: Object,
      default: () => {}
    }
  },
    methods: {
      closeModal() {
          Bus.$emit('close-allotment-index-modal')
      }
    }
}
</script>

<style scoped>
/deep/.v-dialog {
    max-width: 800px;
    overflow: hidden;
}
/deep/ .close-content-btn {
  cursor: pointer;
  width: fit-content;
  position: absolute;
  background: white;
  right: -10px;
  top: -10px;
  border-radius: 50%;
}
/deep/ .v-dialog:not(.v-dialog--fullscreen) {
  position: relative;
  overflow: inherit !important;
}
.item-table-header {
  background: #6C4EAD;
}
.item-table-header th {
  color: white !important;
  font-weight: bold;
}
.item-table-sub-header th {
  font-weight: bold !important;
}
</style>